import { makeStyles } from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import consts from "../../libs/consts";
import { useDispatch } from "react-redux";
//import { actionError } from "../../redux/action/ActionActions";
import { axiosDispatch } from "../../services/network";

import Flex from "../../components/flex/Flex";
import Text from "../../components/text/Text";
import ListItem from "./ListItem";
import { objToQueryStr } from "../../services/utils";
import * as APIS from "../../libs/apis";

export default function List({
  settype,
  onpriceChange,
  currentchFunc,
  height,
}) {
  const dispatch = useDispatch();
  const classes = useStyle();
  const [tradeBuy, settradeBuy] = useState([]);

  // 전일 종가
  const [lastPrice, setLastPrice] = useState(0);

  const timer = useRef(null);

  useEffect(() => {
    startInterval();

    // 앱 백그라운드 상태에서 API 호출 중지를 위한 리스너
    document.addEventListener("message", listener);
    window.addEventListener("message", listener);
    return () => {
      document.removeEventListener("message", listener);
      window.removeEventListener("message", listener);
      stopInterval();
    };
  }, []);

  const listener = (event) => {
    const { command, data } = JSON.parse(event.data);
    if (command === "APP_STATE") {
      if (data === "active") {
        startInterval();
      } else {
        stopInterval();
      }
    }
  };

  const startInterval = () => {
    if (!timer.current) {
      fetchPendingSummary();
      timer.current = setInterval(fetchPendingSummary, 2000);
    }
  };

  const stopInterval = () => {
    clearInterval(timer.current);
    timer.current = false;
  };

  const fetchPendingSummary = () => {
    APIS.getPendingSummary(settype).then(({ data: res }) => {
      var data = [];
      var dataH = [];

      for (let i in res.data) {
        if (res.data[i].tradeType === null) {
          dataH.push(res.data[i]);
          setLastPrice(res.data[i]["remainGram"]);
        } else {
          data.push(res.data[i]);
        }
      }
      settradeBuy(data);
      currentchFunc(dataH);
    });
  };

  function onpriceChangef(price, method) {
    onpriceChange(price, method);
  }

  const contentRef = useRef(null);
  const middleRef = useRef(null);

  useEffect(() => {
    if (!middleRef.current) return;

    const getAbsoluteTop = (element) => {
      return window.pageYOffset + element.getBoundingClientRect().top;
    };

    const parentElement = contentRef.current;
    const parentAbsoluteTop = getAbsoluteTop(parentElement);
    const absoulteTop = getAbsoluteTop(middleRef.current);
    const relativeTop = absoulteTop - parentAbsoluteTop;

    contentRef.current.scrollTo(0, relativeTop - height / 2);
  }, [middleRef.current]);

  const sellList = tradeBuy.filter(({ tradeType }) => tradeType === "SELL");
  const buyList = tradeBuy.filter(({ tradeType }) => tradeType === "BUY");

  return (
    <Flex
      style={{ display: "block", height }}
      className={classes.root}
      innerRef={contentRef}
    >
      <Flex style={{ minHeight: height / 2, justifyContent: "flex-end" }}>
        {sellList.map((row, i) => {
          return (
            <ListItem
              key={i.toString()}
              method="sell"
              data={row}
              onpriceChangef={onpriceChangef}
              lastPrice={lastPrice}
            />
          );
        })}
      </Flex>
      {!!tradeBuy.length && <div ref={middleRef} />}
      <Flex style={{ minHeight: height / 2 }}>
        {buyList.map((row, i) => {
          return (
            <ListItem
              key={i.toString()}
              method="buy"
              data={row}
              onpriceChangef={onpriceChangef}
              lastPrice={lastPrice}
            />
          );
        })}
      </Flex>
    </Flex>
  );
}

const useStyle = makeStyles({
  root: {
    overflowY: "scroll",
    "-webkit-overflow-scrolling": "touch",
    flex: 2,
    alignSelf: "stretch",
  },
});
